import { findKeyParentInObj, findKeyInObj } from '../utils/objects';
import { noticeError } from 'app/api/analytics/reporting';

export function callApiByName(
  methodStr,
  context,
  params = [],
  callback = () => {}
) {
  const apiFunc = findKeyInObj(context, methodStr);
  const apiContext = findKeyParentInObj(context, methodStr);
  if (apiFunc && apiContext) {
    return apiFunc.apply(apiContext, params.concat(callback));
  }
  const message = `Jigsaw API method not found: ${methodStr}`;
  noticeError(message);
  callback({
    isSuccess: () => false,
    message: message,
    code: 404,
    data: {
      errors: null,
    },
  });
}



// WEBPACK FOOTER //
// ./src/app/api/jigsaw-proxy.js